import { render, staticRenderFns } from "./MeasurementSidebar.vue?vue&type=template&id=2e1f5474&"
import script from "./MeasurementSidebar.vue?vue&type=script&lang=js&"
export * from "./MeasurementSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/nc21docker/apps/health/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e1f5474')) {
      api.createRecord('2e1f5474', component.options)
    } else {
      api.reload('2e1f5474', component.options)
    }
    module.hot.accept("./MeasurementSidebar.vue?vue&type=template&id=2e1f5474&", function () {
      api.rerender('2e1f5474', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/measurement/MeasurementSidebar.vue"
export default component.exports